// extracted by mini-css-extract-plugin
module.exports = {"title-with-button__wrapper":"title-with-button__wrapper","title-with-button__title":"title-with-button__title"};